import * as React from "react";
import { FormattedLabelLink } from "../../../../../../../../../../FormattedLabelLink/FormattedLabelLink/FormattedLabelLink.js";
/* empty css                                    */
const ProductBlockIncludesLensesLink = ({ tabIndex }) => {
  return /* @__PURE__ */ React.createElement(
    FormattedLabelLink,
    {
      className: "product-block-includes-lenses-link",
      labelKey: "products.glasses.offering.includesLenses",
      tabIndex
    }
  );
};
export {
  ProductBlockIncludesLensesLink
};
//# sourceMappingURL=ProductBlockIncludesLensesLink.js.map
